<section [formGroup]="group" class="section" *ngIf="group">
  <header class="section-header">
    <h4>Device</h4>
    <span class="hint">{{ requirementLabel }}</span>
  </header>

  <div class="mode-toggle">
    <app-trigger-mode-radio-group
      formControlName="mode"
      [options]="modeOptions"
    ></app-trigger-mode-radio-group>
  </div>

  <p class="hint" *ngIf="mode === 'generate'">
    {{ generateHint }}
  </p>

  <div class="fields" *ngIf="mode === 'specify'">
    <div class="field">
      <label>OS</label>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="system_name"
          (selectionChange)="onSystemNameChange($event.value)"
        >
          <mat-option value="iOS">iOS</mat-option>
          <mat-option value="Android">Android</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field">
      <label>OS Version</label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="system_version" placeholder="e.g. 17.4" />
      </mat-form-field>
    </div>

    <div class="field">
      <label>Make</label>
      <mat-form-field appearance="outline">
        <ng-container *ngIf="systemName === 'iOS'; else androidMake">
          <input matInput formControlName="make" readonly />
        </ng-container>
        <ng-template #androidMake>
          <input matInput formControlName="make" placeholder="e.g. Samsung" />
        </ng-template>
      </mat-form-field>
    </div>

    <div class="field">
      <label>Model</label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="model" placeholder="e.g. iPhone 15 Pro" />
      </mat-form-field>
    </div>
  </div>

  <p class="hint" *ngIf="mode === 'specify'">
    {{ specifyHint }}
  </p>
</section>
